import React from "react";
import { DealHeroCard } from "@loanbossinc/component-library";
import { isEmpty } from "lodash";

import { shouldShowSquareFeet, shouldShowHotelRooms, shouldShowUnits } from "../pages/propertyDetail/property-general-information/section-property-details-rows-logic";
import numberFormatter from "../utils/numberFormatter";

import { determinePriceField } from "./heroCard_Util";

export const PropertyHeroCard = props => {
  const { propertyData,
    backLabel,
    hideButtons,
    rightTopButton,
    buttonListOverride,
    onBackButtonClick,
    save,
    cancel,
    history } = props;
  const { property } = propertyData;

  const getValue = metricId => {
    if (!property) {
      return {};
    }
    const found = property[metricId];

    // passing ternary into decimal count because appraised value should be whole number
    return found ? { metricId, displayValue: metricId === "hotelRooms" ? found : numberFormatter.formatMoney(found, 0, found), decimalValue: found, dateValue: found, integerValue: found } : {};
  };

  const getMetricList = property => {
    const metricList = [
      {
        label: "Purchase Date",
        ...getValue("purchaseDate")
      },
      {
        label: "Purchase Price",
        ...getValue("purchasePrice")
      },
      {
        label: "Market Value",
        ...getValue("marketValue")
      },
      {
        label: "Appraised Value",
        ...getValue("appraisedValue")
      }
    ];

    determinePriceField(metricList);

    const hotelRooms = shouldShowHotelRooms(property) ? { label: "Hotel Rooms", ...getValue("hotelRooms") } : null;
    const mfProperties = shouldShowUnits(property) ? { label: "Units", ...getValue("units") } : null;
    const otherProperties = shouldShowSquareFeet(property) ? { label: "Square Feet", ...getValue("squareFeet") } : null;

    if (!isEmpty(hotelRooms)) {
      metricList.push(hotelRooms);
    }
    if (!isEmpty(mfProperties)) {
      metricList.push(mfProperties);
    }
    if (!isEmpty(otherProperties)) {
      metricList.push(otherProperties);
    }

    return metricList;
  };

  const standardButtonList = [
    { label: "Save Changes", onClick: save },
    { label: "Reset", onClick: cancel }
  ];

  const buttonList = () => {
    if (hideButtons) {
      return [];
    }
    if (buttonListOverride) {
      return buttonListOverride;
    }

    return standardButtonList;
  };

  const standardTopButton = [
    {
      label: backLabel,
      iconName: "arrow_forward",
      topButtonAlignment: "left",
      onClick: () => (onBackButtonClick ? onBackButtonClick() : history.goBack())
    }
  ];

  const topButtons = !rightTopButton ? standardTopButton : [...standardTopButton, rightTopButton];

  return (
    <>
      {!property && null}
      <DealHeroCard
        title={!property || property.address}
        dealMetricList={getMetricList(property)}
        topButtons={topButtons}
        buttonList={buttonList()}
        displayMetrics
      />
    </>
  );
};
